import styled from 'styled-components';

export const StyledPanelContainer = styled.div`
    margin-left: 16px;
    margin-right: 16px;
    vertical-align: middle;
`;

export const LayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledHeaderContainer = styled.div`
    height: 64px;
    background-color: ${(props) => props.theme.colors.primary.main};
    display: flex;
    margin-bottom: 20px;
`;

export const StyledHeaderText = styled.span`
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    color: ${(props) => props.theme.colors.secondary.lightBackground};
    line-height: 64px;
    letter-spacing: 0px;
    text-align: left;
    vertical-align: middle;
    padding-left: 20px;
`;

export const StyledButtonContainer = styled.div`
    display: flex;
`;

export const StyledButtonGroup = styled.div`
    margin-left: 10px;
    display: flex;
    justifycontent: flex-end;
`;

export const StyledSpacedButtonGroup = styled.div`
    margin-left: 10px;
    display: flex;
    justifycontent: space-between;
`;

export const StyledRowContainer = styled.div`
    vertical-align: middle;
    display: flex;
    min-height: 24px;
    align-items: left;
`;

export const StyledBottomRowContainer = styled.div`
    vertical-align: middle;
    display: flex;
    min-height: 24px;
    align-items: left;
    width: 95%;
    justify-content: flex-end;
    bottom: 10px;
    marginBottom: 25px;
`;

export const StyledRowItemContainer = styled.div`
    vertical-align: middle;
    display: flex;
    min-height: 24px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const StyledRowButtonsContainer = styled.div`
    display: flex;
    min-height: 24px;
    justify-content: flex-end;
    align-items: center;
    marginLeft: 10px;
`;

export const StyledRowItemsLeftJustContainer = styled.div`
    vertical-align: middle;
    display: flex;
    min-height: 24px;
    align-items: left;
    marginLeft: 10px;
`;

export const StyledRowItemsRightJustContainer = styled.div`
    vertical-align: middle;
    display: flex;
    min-height: 24px;
    align-items: right;
    marginLeft: 10px;
`;

export const StyledUserContainer = styled.div`
    vertical-align: middle;
    display: flex;
    min-height: 24px;
    margin-bottom: 15px;
    justify-content: space-between;
    width = 100%;
`;

export const StyledSubButtonGroup = styled.div`
    margin-left: 10px;
    margin-right: 10px;
    vertical-align: middle;
    display: flex;
    justify-content: space-between;
`;

export const StyledSubMenuContainer = styled.div`
    display: flex;
    vertical-align: middle;
    horizontal-align: middle;
    justify-content: center;
`;

export const StyledUserInitial = styled.div`
    width: 24px;
    border-radius: 12px;
    background-color: ${(props) => props.theme.colors.primary.main};
    color: white;
    align-content: middle;
    justify-content: center;
    text-align: center;
    margin-right: 10px;
`;
